// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leftSide {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
.leftSide .logo {
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.leftSide .logo img {
  max-height: 105px;
}
.leftSide .error {
  flex-grow: 3;
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: start;
}
.rightSide {
  display: flex;
  flex-direction: column;
  background-size: cover;
  background-position: center;
}
.rightSide .overlay {
  background: linear-gradient(309.36deg, #F495D8 0%, #6644CC 100%);
  height: 100vh;
  opacity: 0.9;
  padding: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.rightSide .overlay h1 {
  margin-bottom: 30px;
}
`, "",{"version":3,"sources":["webpack://./src/app/Views/Security/UnknownRoute.less"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AADF;AAJA;EAQI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AADJ;AAVA;EAcM,iBAAA;AADN;AAbA;EAmBI,YAAA;EACA,aAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;AAHJ;AASA;EACE,aAAA;EACA,sBAAA;EAEA,sBAAA;EACA,2BAAA;AARF;AAGA;EAQI,gEAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AARJ;AANA;EAiBM,mBAAA;AARN","sourcesContent":["@import '~common-controls/Style/Colors.less';\n\n.leftSide {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n\n  .logo {\n    flex-grow: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    img {\n      max-height: 105px;\n    }\n  }\n\n  .error {\n    flex-grow: 3;\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n    align-items: center;\n    justify-content: start;\n  }\n}\n\n\n\n.rightSide {\n  display: flex;\n  flex-direction: column;\n  //background-image: url('/content/images/LoginNurseBG.jpg');\n  background-size: cover;\n  background-position: center;\n\n  .overlay {\n    background: linear-gradient(309.36deg, #F495D8 0%, #6644CC 100%);\n    height: 100vh;\n    opacity: 0.9;\n    padding: 100px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n\n    h1 {\n      margin-bottom: 30px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
